import React, { useEffect, useState } from 'react';
import { CloseableModal } from '../../../../../../../../components/CloseableModal';
import { InputFormField } from '../../../../../../../../components/InputFormField';
import { Button } from 'reactstrap';
import { JobRequisitionReasonService } from '../../../../../../../../services/v1/applicant_tracking/JobRequisitionReasonService';
import { UseFormSetValue } from 'react-hook-form';
import { JobRequisitionDto } from '../../../../../../../../services/applicant_tracking/JobRequisitionService/CreateJobRequisitionDto';

interface PropTypes {
  isOpen: boolean;
  refetchData: () => void;
  setIsOpen: (isOpen: boolean) => void;
  setValue?: UseFormSetValue<JobRequisitionDto>;
}

function Body(props: {
  name: string;
  setName: (name: string) => void;
  error?: string;
}) {
  return (
    <InputFormField
      type='text'
      maxLength={65}
      showMaxLengthCounter
      setValueOnChange={props.setName}
      error={props.error}
      classNames='fs-5'
      fieldName='Reason Name'
      placeholder='Insert Reason Name'
      defaultValue={props.name}
      isRequired={true}
      fontSize='fs-5'
      headerClassNames='fw-semibold mb-0'
    />
  );
}

export function CreateRequisitionReasonModal(props: PropTypes) {
  const [name, setName] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    setName(null);
    setError(null);
  }, [props.isOpen]);

  return (
    <CloseableModal
      isOpen={props.isOpen}
      className='modal-dialog-centered'
      size='md'
      headerTitle='Create Requisition Reason'
      onClose={() => props.setIsOpen(false)}
      bodyChildren={<Body error={error} name={name} setName={setName} />}
      footerChildren={
        <>
          <Button color='danger' onClick={() => props.setIsOpen(false)}>
            Cancel
          </Button>
          <Button
            color='primary'
            onClick={() => {
              JobRequisitionReasonService.create(name)
                .then((reason) => {
                  props.setValue('jobRequisitionReasonId', reason.id);
                  props.refetchData();
                  props.setIsOpen(false);
                })
                .catch((e) => setError(e.body.message));
            }}
          >
            Create and Select Reason
          </Button>
        </>
      }
    />
  );
}
